import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserLogin = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解2：注册及登录
          </Title>
          <div className="text-lg">
            <p>在登录/注册页面，可以选择手机号快捷登录、密码登录、其他方式登录。</p>
            <p>在快捷登录选项中，填写手机号后点击发送验证码，手机会收到系统发送的验证码，填入验证码，新用户即可自动注册账号并登录，老用户会自动登录自己的账户。</p>
            <p>已经拥有灵缇互娱账号的老用户，还可点击下面其他方式的图标，在微信快捷登录、手机号登录之间切换。</p>
            <div className="my-4">
              <Image src="/manual/register_and_login/1.png" alt="" />
            </div>
            <p>用户权限：</p>
            <p>注册成功后，用户即可获得免费使用权限。如果需要 VIP 权限，可按月/年购买，以获得更多功能和权限。</p>
            <div className="my-4">
              <Image src="/manual/register_and_login/2.png" alt="" />
            </div>
            <div className="my-4">
              <Image src="/manual/register_and_login/3.png" alt="" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserLogin, {
  title: '注册与登录 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统注册登录说明:手机号验证码快捷登录、密码登录、微信登录,注册后即获免费使用权限,VIP 权限可按月/年购买。',
})

export default UserLogin
